

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyADI2ZIUa9t8OHO-NzRSjuM93eeMlpUy48",
  authDomain: "eyecare-student-attendance.firebaseapp.com",
  projectId: "eyecare-student-attendance",
  storageBucket: "eyecare-student-attendance.firebasestorage.app",
  messagingSenderId: "862391156845",
  appId: "1:862391156845:web:a22c59ae84062044d6bf64"
};
  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection };  // Correct export
















